var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "280.000000pt",
    height: "182.000000pt",
    viewBox: "0 0 280.000000 182.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,182.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 910 l0 -910 1400 0 1400 0 0 910 0 910 -1400 0 -1400 0 0 -910z m2720 0 l0 -830 -1320 0 -1320 0 0 830 0 830 1320 0 1320 0 0 -830z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 905 l0 -546 103 3 102 3 5 392 5 391 94 -361 c52 -199 98 -377 103 -395 l9 -33 106 3 106 3 101 387 101 388 5 -388 5 -387 103 -3 102 -3 0 546 0 545 -168 0 -168 0 -84 -322 c-107 -414 -101 -390 -105 -386 -3 3 -185 695 -185 704 0 2 -76 4 -170 4 l-170 0 0 -545z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572 908 l3 -543 180 -3 c99 -1 232 2 295 7 156 12 217 36 295 115 105 105 145 223 145 427 0 289 -111 468 -325 524 -46 12 -119 15 -327 15 l-268 0 2 -542z m511 341 c52 -14 110 -69 136 -128 62 -146 46 -409 -31 -496 -54 -62 -77 -69 -240 -73 l-148 -4 0 356 0 356 123 0 c67 0 139 -5 160 -11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdDark);
export default __webpack_public_path__ + "static/media/md_dark.99b1227f5baf6e6bf8b80b874364b50b.svg";
export { ForwardRef as ReactComponent };